import React from 'react'
import Navbar from './Navbar';
import Cookies from 'js-cookie';
const Contact = () => {
  return (
    <div>
      <div>
        <Navbar />
      </div>
      <div style={{marginTop : "250px"}}>
        <h1 className='flex justify-center text-3xl'>Contact us</h1>
      </div>
    </div>
  )
}

export default Contact;